import { createBrowserRouter } from "react-router-dom";
import routesArr from "./config";

const router = createBrowserRouter(routesArr);

export default router;